var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._t("header"),_c('apexchart',{staticClass:"w-100",attrs:{"id":"donut-chart","height":_vm.height,"options":_vm.chartOptions,"series":_vm.series}})],2)}
var staticRenderFns = []

export { render, staticRenderFns }